"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyValueSchema = void 0;
exports.KeyValueSchema = {
    "$id": "https://www.redbull.com/schemas/attributes/key-value.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "KeyValue",
    "description": "Stores multiple key-value pairs e.g. to store theme configuration",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "attributes:key-value"
            ]
        },
        "elements": {
            "type": "array",
            "items": {
                "type": "object",
                "additionalProperties": false,
                "properties": {
                    "key": {
                        "type": "string"
                    },
                    "value": {
                        "$ref": "https://www.redbull.com/schemas/attributes/text.schema.json"
                    }
                },
                "required": [
                    "key",
                    "value"
                ]
            }
        }
    },
    "required": [
        "elements",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoia2V5LXZhbHVlLnNjaGVtYS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9tb2R1bGVzL2F0dHJpYnV0ZXMva2V5LXZhbHVlLnNjaGVtYS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLGNBQWMsR0FBRztJQUM1QixLQUFLLEVBQUUsa0VBQWtFO0lBQ3pFLFNBQVMsRUFBRSw4Q0FBOEM7SUFDekQsT0FBTyxFQUFFLFVBQVU7SUFDbkIsYUFBYSxFQUFFLG1FQUFtRTtJQUNsRixNQUFNLEVBQUUsUUFBUTtJQUNoQixzQkFBc0IsRUFBRSxLQUFLO0lBQzdCLFlBQVksRUFBRTtRQUNaLE1BQU0sRUFBRTtZQUNOLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRTtnQkFDTixzQkFBc0I7YUFDdkI7U0FDRjtRQUNELFVBQVUsRUFBRTtZQUNWLE1BQU0sRUFBRSxPQUFPO1lBQ2YsT0FBTyxFQUFFO2dCQUNQLE1BQU0sRUFBRSxRQUFRO2dCQUNoQixzQkFBc0IsRUFBRSxLQUFLO2dCQUM3QixZQUFZLEVBQUU7b0JBQ1osS0FBSyxFQUFFO3dCQUNMLE1BQU0sRUFBRSxRQUFRO3FCQUNqQjtvQkFDRCxPQUFPLEVBQUU7d0JBQ1AsTUFBTSxFQUFFLDZEQUE2RDtxQkFDdEU7aUJBQ0Y7Z0JBQ0QsVUFBVSxFQUFFO29CQUNWLEtBQUs7b0JBQ0wsT0FBTztpQkFDUjthQUNGO1NBQ0Y7S0FDRjtJQUNELFVBQVUsRUFBRTtRQUNWLFVBQVU7UUFDVixNQUFNO0tBQ1A7Q0FDRixDQUFBIn0=